/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ResolveChatParticipantsResponse = zod.object({
  actors: zod.array(
    zod.object({
      avatarUrl: zod
        .string()
        .nullable()
        .describe(
          'Profile-image URL when one exists. Caller-authorized: it loads only when the caller holds a READ edge on the underlying image file and may answer 403 — treat a failed load as ordinary and fall back to initials.',
        ),
      groupRole: zod
        .enum(['admin', 'member'])
        .optional()
        .describe(
          "Only when the request names a thread that is a group's own chat (PRD-2334) and the caller is in that group: admin for a holder of the group's Admin role (shown as Leader), member for anyone else in the group. Absent for someone no longer in the group, and on every other thread.",
        ),
      name: zod.string(),
      reachUserId: zod.string(),
    }),
  ),
  invitations: zod.array(
    zod.object({
      display: zod
        .string()
        .nullable()
        .describe(
          'Full identifier for the invitation creator; masked for other thread members; the profile name (under existing visibility) for actor-keyed entries; null when nothing may be shown',
        ),
      id: zod.uuid().describe('UUID v4 identifier'),
      kind: zod.enum(['email', 'phone', 'actor']),
      status: zod.enum(['open', 'claimed', 'revoked', 'expired']),
    }),
  ),
});

export type ResolveChatParticipantsResponse = zod.input<typeof ResolveChatParticipantsResponse>;
export type ResolveChatParticipantsResponseOutput = zod.output<
  typeof ResolveChatParticipantsResponse
>;
